import { Input, Label } from "reactstrap";

const ActiveOrderTableHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <div className="form-check">
            <Input type="checkbox" />
            <Label className="form-check-label" />
          </div>
        </th>
        <th>Date</th>
        <th>Type</th>
        <th>Customer</th>
        <th>Price</th>
        <th>Usd </th>
        <th>Status</th>
      </tr>
    </thead>
  );
};

export default ActiveOrderTableHeader;
